import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appHighlightData]',
    standalone: true,
})
export class HighlightDataDirective {
    @HostBinding('style.font-weight') readonly fontWeight = '600';
}
